import React, { useContext } from 'react'
import { context as RehearsalContext } from '../../context/rehearsal'
import {
  FollowerBarContainer,
  EndedBarContainer,
  StatusSection,
  StatusLabel,
  StatusInfo,
  LeaveButton,
  ActionSection,
  HomeLink
} from '../../styled/rehearsal-follower-bar'

const RehearsalFollowerBar = () => {
  const {
    rehearsal,
    isFollowing,
    rehearsalEnded,
    leaveRehearsal,
    dismissEndedRehearsal,
    loading
  } = useContext(RehearsalContext)

  // Show ended state when rehearsal has ended
  if (rehearsalEnded && rehearsal) {
    const ownerName = rehearsal.owner?.profile?.name ||
                     rehearsal.owner?.email ||
                     'The rehearsal owner'
    const groupName = rehearsal.group?.title ||
                     rehearsal.group?.name ||
                     'the group'

    return (
      <EndedBarContainer>
        <StatusSection>
          <StatusLabel>Rehearsal Ended</StatusLabel>
          <StatusInfo>
            {ownerName} has ended the rehearsal for {groupName}
          </StatusInfo>
        </StatusSection>
        <ActionSection>
          <HomeLink to='/' onClick={dismissEndedRehearsal}>
            Return Home
          </HomeLink>
          <LeaveButton onClick={dismissEndedRehearsal} disabled={loading}>
            Dismiss
          </LeaveButton>
        </ActionSection>
      </EndedBarContainer>
    )
  }

  // Only display when user is following a rehearsal
  if (!isFollowing || !rehearsal) {
    return null
  }

  const handleLeave = () => {
    leaveRehearsal()
  }

  const groupName = rehearsal.group?.title || rehearsal.group?.name || 'Unknown Group'
  const ownerName = rehearsal.ownerInfo?.firstName && rehearsal.ownerInfo?.lastName
    ? `${rehearsal.ownerInfo.firstName} ${rehearsal.ownerInfo.lastName}`
    : 'Unknown'

  return (
    <FollowerBarContainer>
      <StatusSection>
        <StatusLabel>Following Rehearsal</StatusLabel>
        <StatusInfo>
          Group: {groupName}
        </StatusInfo>
        <StatusInfo>
          Owner: {ownerName}
        </StatusInfo>
      </StatusSection>
      <LeaveButton onClick={handleLeave} disabled={loading}>
        Leave Rehearsal
      </LeaveButton>
    </FollowerBarContainer>
  )
}

export default RehearsalFollowerBar
